export default __webpack_public_path__ + "static/media/booknow.0544daee.jpg";